import { render, staticRenderFns } from "./SubRoute.vue?vue&type=template&id=184a269a&"
import script from "./SubRoute.vue?vue&type=script&lang=js&"
export * from "./SubRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports